<template>
  <div class="new-meeting-type-modal">
    <HMModalHeader
      :title="$t('MARKETING.TITLES.NEW_MEETING_TYPE')"
      @close="$emit('close')"
    />
    <form @submit.prevent="submit">
      <div class="form-group">
        <HMTextInput
          v-model="newMeetingType.name"
          :label="$t('MARKETING.LABELS.MEETING_TYPE_NAME')"
          :placeholder="$t('MARKETING.PLACEHOLDERS.MEETING_TYPE_NAME')"
          rules="required|max:128"
        ></HMTextInput>
      </div>
      <div class="form-group">
        <label>
          {{ $t('PRODUCTS.LABELS.SESSION_DURATION') }}
        </label>
        <v-select
          :options="durations()"
          v-model="newMeetingType.duration_minutes"
          :clearable="false"
          :taggable="true"
          :reduce="r => r.code"
          @option:created="meetingTypeDurationOptionCreated"
        ></v-select>
      </div>
      <HMModalFooter
        class="mt-3"
        :submitButton="$t('GENERAL.BUTTON.CONFIRM')"
        :discardButton="$t('GENERAL.BUTTON.CANCEL')"
        @close="$emit('close')"
      />
    </form>
  </div>
</template>

<script>
import { HMModalFooter, HMModalHeader } from '@/web/components/common';
import HMTextInput from '../common/HMTextInput';
import { parseDuration } from '../../../core/utils/products';
import slugify from '@/core/utils/slugify';
import {
  durations,
  meetingTypeDurationOptionCreated,
} from '../../../core/utils/meetings';

export default {
  name: 'NewMeetingTypeModal',
  components: {
    HMTextInput,
    HMModalHeader,
    HMModalFooter,
  },
  props: {
    confirmFn: null,
  },
  data() {
    return {
      newMeetingType: {
        name: null,
        duration_minutes: 30,
        slug: null,
      },
    };
  },
  methods: {
    durations() {
      return durations();
    },
    meetingTypeDurationOptionCreated(option) {
      meetingTypeDurationOptionCreated(option);
    },
    submit() {
      this.newMeetingType.slug = slugify(this.newMeetingType.name);
      this.confirmFn && this.confirmFn(this.newMeetingType);
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
